var exports = {
  "k": "x234b8571--d5b4e8--image-wrapper",
};

module.exports = exports;
